/**
 * Glitch Events — per-turn-cycle chaos modifiers that escalate as the match progresses.
 * "The arena is your enemy."
 */

// Glitch IDs (numeric for clean sync)
export const GLITCH_NONE = 0;
export const GLITCH_MASSIVE_KNOCKBACK = 1;
export const GLITCH_QUAKE_SLAM = 2;
export const GLITCH_HUGE_RECOIL = 3;
export const GLITCH_SHOCKWAVE_RING = 4;
export const GLITCH_GRAVITY_WELL = 5;
export const GLITCH_CHAIN_SHOCK = 6;
export const GLITCH_LOW_GRAVITY = 7;

export const GLITCH = {
  // Roll chance per turn cycle
  ROLL_CHANCE: 0.6,

  // Tier pools by turn number threshold
  TIER1_MAX_TURN: 3,
  TIER2_MAX_TURN: 6,

  // Tier 1 effects
  MASSIVE_KNOCKBACK_MULT: 2.5,
  QUAKE_SLAM_RADIUS: 30,
  QUAKE_SLAM_DAMAGE: 5,
  HUGE_RECOIL_FORCE: 6,

  // Tier 2 effects
  SHOCKWAVE_RING_RADIUS: 200,
  SHOCKWAVE_RING_FORCE: 3,
  GRAVITY_WELL_FORCE: 4,
  CHAIN_SHOCK_RADIUS: 300,
  CHAIN_SHOCK_DAMAGE_MULT: 0.1,
  LOW_GRAVITY_MULT: 0.4,

  // Announcement colors by tier
  TIER1_COLOR: 0xffaa00,
  TIER2_COLOR: 0xff4400,
  TIER3_COLOR: 0xff00ff,
} as const;

/** Glitch registry — ID, name, description, tier. */
export const GLITCH_REGISTRY: ReadonlyArray<{
  id: number;
  name: string;
  desc: string;
  tier: number;
}> = [
  { id: GLITCH_MASSIVE_KNOCKBACK, name: 'MASSIVE KNOCKBACK', desc: 'Explosions hit HARDER', tier: 1 },
  { id: GLITCH_QUAKE_SLAM, name: 'QUAKE SLAM', desc: 'Landings destroy terrain', tier: 1 },
  { id: GLITCH_HUGE_RECOIL, name: 'HUGE RECOIL', desc: 'Shots push you back', tier: 1 },
  { id: GLITCH_SHOCKWAVE_RING, name: 'SHOCKWAVE RING', desc: 'Explosions send shockwaves', tier: 2 },
  { id: GLITCH_GRAVITY_WELL, name: 'GRAVITY WELL', desc: 'Explosions pull you in', tier: 2 },
  { id: GLITCH_CHAIN_SHOCK, name: 'CHAIN SHOCK', desc: 'Damage chains to nearby tanks', tier: 2 },
  { id: GLITCH_LOW_GRAVITY, name: 'LOW GRAVITY', desc: 'Everything floats', tier: 2 },
];
